


































import { Vue, Component } from 'vue-property-decorator';
import { Button } from 'vant';
import { baseinfo } from '@/api/commonApi';
import { FileType } from '@/common/ts/enum';
import { addPv } from '@/common/ts/common';
import {
  VoteButton,
  VoteList,
  BottomTabbar,
  NewsList,
  TextInput,
  Uploader,
  Banner,
  PickerInput,
  SyVoteList,
} from '@/components';
import * as config from './config.example';

Vue.use(Button);

@Component({
  components: {
    VoteButton,
    VoteList,
    BottomTabbar,
    NewsList,
    TextInput,
    Uploader,
    Banner,
    PickerInput,
    SyVoteList,
  },
})
export default class HelloWorld extends Vue {
  baseInfo: object = {};
  voteName = '2019poject/2019countryside';
  listType = { type: 'com' };
  FileType = FileType;
  tabs = [
    {
      tabName: '首页',
      tabPath: '/',
    },
    {
      tabName: '新闻',
      tabPath: '/news',
    },
  ];
  pikerData = ['杭州', '宁波', '温州', '嘉兴', '湖州'];
  options = config.OPTHINES;
  loadingStatus = false;
  created() {
    // 添加pv
    this.$addPv(9);
  }
  getOssImagesUrls(result: any) {
    console.log(result);
  }
  selectPickerData(e: string) {
    console.log('出来了', e);
  }
  onNavTo(voteItem: any) {
    console.log(voteItem);
  }
}
